import { loaderAction, setPriceForSubscriptionAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";

export const getPriceForSubscriptionThunk = (args) => async (dispatch, getState) => {
    const { user, currentEstablishment, currentUser } = getState();

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);

        formData.append('user', currentUser.id || '');

        const response = await api({ data: formData, link: 'get_p_for_subscription' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            dispatch(setPriceForSubscriptionAction(response.price_for_subscription));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
};